module.exports = __webpack_public_path__ + "35faf647bb41a1a9.css";